import apiSlice from "./ApiSlice";

const instituteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllInstituteData: builder.query({
      providesTags: ["institute"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/institute",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteInstituteById: builder.mutation({
      invalidatesTags: ["institute"],
      query: (id: any) => ({
        url: `/institute/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addInstitute: builder.mutation({
      invalidatesTags: ["institute"],
      query: (body) => ({
        url: `/institute/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getInstituteById: builder.query({
      providesTags: ["institute"],
      query: (id: string) => {
        return {
          url: `/institute/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateInstituteById: builder.mutation({
      invalidatesTags: ["institute"],
      query: ({ body, id }) => ({
        url: `/institute/${id}`,
        method: "PUT",
        body,
      }),
    }),

    //get Allinstitutes
    getAllInstitutes: builder.query({
      providesTags: ["institute"],
      query: () => {
        return {
          url: `/institute`,
          method: "GET",
        };
      },
    }),

      
    // change status of delivery date
    changeStatusInstituteById: builder.mutation({
      invalidatesTags: ["institute"],
      query: ({ body, id }) => ({
        url: `/institute/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllInstituteDataQuery,
  useDeleteInstituteByIdMutation,
  useAddInstituteMutation,
  useGetInstituteByIdQuery,
  useGetAllInstitutesQuery,
  useUpdateInstituteByIdMutation,
  useChangeStatusInstituteByIdMutation,
} = instituteApi;
